<script setup lang="ts">
import type { SelectGroupOption } from 'naive-ui'
import type { TaskOption } from './task-option.type'
import { copyFeatureNotSupportedHint } from '~/constants'

const props = defineProps({
  option: {
    type: Object as PropType<TaskOption | SelectGroupOption>,
    required: true,
  },
})

const clipboardStore = useClipboardStore()
const { isAnyResourceCopied, task, canWriteToClipboard } = storeToRefs(clipboardStore)

function isTaskOption(option: typeof props.option): option is TaskOption {
  return option.type !== 'group'
}

const icon = computed(() => {
  return isAnyResourceCopied.value && task.value?.id === props.option.value ? 'i-ic-outline-library-add-check' : 'i-ic-baseline-content-copy'
})
</script>

<template>
  <div class="flex items-center justify-between group/option space-x-2">
    <NTooltip>
      <template #trigger>
        <span class="truncate">{{ option.label }}</span>
      </template>
      {{ option.label }}
    </NTooltip>
    <NTooltip v-if="isTaskOption(option)">
      <template #trigger>
        <NButton
          size="small"
          quaternary
          class="opacity-40 group-hover/option:opacity-100 copy-button"
          :disabled="!canWriteToClipboard"
          @click.stop="clipboardStore.copyTask(option.task)"
        >
          <template #icon>
            <UIcon :name="icon" />
          </template>
        </NButton>
      </template>
      <span v-if="canWriteToClipboard">Aufgabe kopieren</span>
      <span v-else>{{ copyFeatureNotSupportedHint }}</span>
    </NTooltip>
  </div>
</template>
